module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n        Identificação \n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" "), [_vm._v("Validação de token")]], 2), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('p', [_vm._v("Escolha um canal para validar seu código: ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row border-row row-fix"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "content-box-small margin-t80"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger margin-b20",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.errorMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "false"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doRequest.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "chooseChannel"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelSelected),
      expression: "channelSelected"
    }],
    attrs: {
      "id": "chooseEmailId",
      "type": "radio",
      "value": "EMAIL",
      "name": "chooseChannelForm"
    },
    domProps: {
      "checked": _vm._q(_vm.channelSelected, "EMAIL")
    },
    on: {
      "change": function($event) {
        _vm.channelSelected = "EMAIL"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "chooseEmailId"
    }
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelSelected),
      expression: "channelSelected"
    }],
    attrs: {
      "id": "chooseCellphoneId",
      "type": "radio",
      "value": "SMS",
      "name": "chooseChannelForm"
    },
    domProps: {
      "checked": _vm._q(_vm.channelSelected, "SMS")
    },
    on: {
      "change": function($event) {
        _vm.channelSelected = "SMS"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "chooseCellphoneId"
    }
  }, [_vm._v("Celular")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-purple",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "id": "btn-login",
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("\n                  Continuar\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-circle-right align-icon"
  })])])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-back margin-t20",
    attrs: {
      "to": "/login",
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n        Voltar\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "circle-key"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-1ca2fb6a!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/choose-channel-interno.vue
// module id = 2059
// module chunks = 1